<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="dedication"><a id="page_v"></a><em>For Mom, Dad, and Tana—<br/>and the friends I made and the family I found<br/>at Bouchercon 2007 (Anchorage)</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?8247cbbc